import {
  LottoResultsDividerProps,
  LottoResultsDividerVariant,
} from './LottoResultsDivider.types'

const variantStyles: Record<
  LottoResultsDividerVariant,
  { wrapper: string; borderColorVar: string; textColorVar: string }
> = {
  normal: {
    wrapper: 'mb-3',
    borderColorVar: 'border-[var(--lotto-card-divider-border)]',
    textColorVar: 'text-[var(--lotto-card-text)]',
  },
  yeekee: {
    wrapper: 'mb-3 pr-0',
    borderColorVar: 'border-[var(--yeekee-divider-color)]',
    textColorVar: 'text-[var(--yeekee-divider-text-color)]',
  },
  thai: {
    wrapper: 'mb-1 md:mb-3',
    borderColorVar: 'border-[var(--lotto-card-divider-border)]',
    textColorVar: 'text-[var(--lotto-card-text)]',
  },
}

const LottoResultsDivider: React.FC<LottoResultsDividerProps> = ({
  label,
  variant = 'normal',
}) => {
  const { wrapper, borderColorVar, textColorVar } = variantStyles[variant]

  return (
    <div
      data-variant={variant}
      className={`flex items-center ${wrapper} ${textColorVar}`}
    >
      <div className={`flex-grow border-t ${borderColorVar}`} />
      <span className="px-2 text-xs">{label}</span>
      <div className={`flex-grow border-t ${borderColorVar}`} />
    </div>
  )
}

export default LottoResultsDivider
